import { FileAccess } from '../../../../base/common/network.js';
import { localizeWithPath } from '../../../../nls.js';
const _moduleId = "vs/workbench/services/extensionManagement/common/extensionManagement";
const getDefaultIconPath = () => ( (( (FileAccess.asBrowserUri('vs/workbench/services/extensionManagement/common/media/defaultIcon.png'))).toString(true)));
const extensionsConfigurationNodeBase = {
    id: 'extensions',
    order: 30,
    title: ( localizeWithPath(_moduleId, 0, "Extensions")),
    type: 'object'
};
export { extensionsConfigurationNodeBase, getDefaultIconPath };
